 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062190581_COVER from '@/components/Text/9780062190581_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062190581_TITLEPAGE from '@/components/Text/9780062190581_TitlePage'
 import TEXT9780062190581_DEDICATION from '@/components/Text/9780062190581_Dedication'
 import TEXT9780062190581_EPIGRAPH from '@/components/Text/9780062190581_Epigraph'
 import TEXT9780062190581_CONTENTS from '@/components/Text/9780062190581_Contents'
 import TEXT9780062190581_BEFORE from '@/components/Text/9780062190581_Before'
 import TEXT9780062190581_ONE from '@/components/Text/9780062190581_One'
 import TEXT9780062190581_TWO from '@/components/Text/9780062190581_Two'
 import TEXT9780062190581_THREE from '@/components/Text/9780062190581_Three'
 import TEXT9780062190581_FOUR from '@/components/Text/9780062190581_Four'
 import TEXT9780062190581_FIVE from '@/components/Text/9780062190581_Five'
 import TEXT9780062190581_SIX from '@/components/Text/9780062190581_Six'
 import TEXT9780062190581_SEVEN from '@/components/Text/9780062190581_Seven'
 import TEXT9780062190581_EIGHT from '@/components/Text/9780062190581_Eight'
 import TEXT9780062190581_NINE from '@/components/Text/9780062190581_Nine'
 import TEXT9780062190581_TEN from '@/components/Text/9780062190581_Ten'
 import TEXT9780062190581_ELEVEN from '@/components/Text/9780062190581_Eleven'
 import TEXT9780062190581_TWELVE from '@/components/Text/9780062190581_Twelve'
 import TEXT9780062190581_THIRTEEN from '@/components/Text/9780062190581_Thirteen'
 import TEXT9780062190581_FOURTEEN from '@/components/Text/9780062190581_Fourteen'
 import TEXT9780062190581_FIFTEEN from '@/components/Text/9780062190581_Fifteen'
 import TEXT9780062190581_SIXTEEN from '@/components/Text/9780062190581_Sixteen'
 import TEXT9780062190581_SEVENTEEN from '@/components/Text/9780062190581_Seventeen'
 import TEXT9780062190581_EIGHTEEN from '@/components/Text/9780062190581_Eighteen'
 import TEXT9780062190581_NINETEEN from '@/components/Text/9780062190581_Nineteen'
 import TEXT9780062190581_TWENTY from '@/components/Text/9780062190581_Twenty'
 import TEXT9780062190581_TWENTYONE from '@/components/Text/9780062190581_Twenty-one'
 import TEXT9780062190581_TWENTYTWO from '@/components/Text/9780062190581_Twenty-two'
 import TEXT9780062190581_TWENTYTHREE from '@/components/Text/9780062190581_Twenty-three'
 import TEXT9780062190581_TWENTYFOUR from '@/components/Text/9780062190581_Twenty-four'
 import TEXT9780062190581_TWENTYFIVE from '@/components/Text/9780062190581_Twenty-five'
 import TEXT9780062190581_TWENTYSIX from '@/components/Text/9780062190581_Twenty-six'
 import TEXT9780062190581_TWENTYSEVEN from '@/components/Text/9780062190581_Twenty-seven'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062190581_ACKNOWLEDGMENTS from '@/components/Text/9780062190581_Acknowledgments'
 import TEXT9780062190581_ATA from '@/components/Text/9780062190581_ATA'
 import TEXT9780062190581_OTHERWORKS from '@/components/Text/9780062190581_OtherWorks'
 import TEXT9780062190581_CREDITS from '@/components/Text/9780062190581_Credits'
 import TEXT9780062190581_COPYRIGHT from '@/components/Text/9780062190581_Copyright'
 import TEXT9780062190581_ATP from '@/components/Text/9780062190581_ATP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/9780062190581_Contents",
 			"name" : "Text/9780062190581_Contents",
 			"component" : TEXT9780062190581_CONTENTS
 		},
 		{
 			"path" : "/Text/9780062190581_Before",
 			"name" : "Text/9780062190581_Before",
 			"component" : TEXT9780062190581_BEFORE
 		},
 		{
 			"path" : "/Text/9780062190581_One",
 			"name" : "Text/9780062190581_One",
 			"component" : TEXT9780062190581_ONE
 		},
 		{
 			"path" : "/Text/9780062190581_Two",
 			"name" : "Text/9780062190581_Two",
 			"component" : TEXT9780062190581_TWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js